import { render, staticRenderFns } from "./cahierDashTeacher.vue?vue&type=template&id=0e053604&"
import script from "./cahierDashTeacher.vue?vue&type=script&lang=js&"
export * from "./cahierDashTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports